var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#39005C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1476 20.3343C19.2587 20.2232 19.1476 20.3343 18.8143 19.3345C18.3928 18.0699 17.4813 17.335 15.1485 17.335C13.7163 17.335 12.9776 17.662 12.5106 18.015C12.2638 18.2016 12.1491 18.5086 12.1491 18.818V22.4928C12.1491 22.995 12.4686 23.4445 12.9517 23.5815C14.4246 23.9991 16.7175 24.442 19.1476 24.0002C22.0803 23.467 23.0515 22.0006 23.48 21.0008C24.4798 18.668 23.1467 17.8015 22.4802 18.3347C20.8139 19.6678 20.8139 20.3343 19.1476 20.3343ZM19.1476 20.3343H16.1482",
    stroke: "#39005C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14996 17.6685C8.14996 16.9323 8.74679 16.3354 9.48301 16.3354H10.8161C11.5523 16.3354 12.1491 16.9323 12.1491 17.6685V23.0007C12.1491 23.7369 11.5523 24.3337 10.8161 24.3337H9.48301C8.74679 24.3337 8.14996 23.7369 8.14996 23.0007V17.6685Z",
    stroke: "#39005C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.3984 12.7744C22.3984 14.1325 21.2974 15.2335 19.9394 15.2335C18.5813 15.2335 17.4803 14.1325 17.4803 12.7744C17.4803 11.4164 18.5813 10.3154 19.9394 10.3154C21.2974 10.3154 22.3984 11.4164 22.3984 12.7744Z",
    stroke: "#39005C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.975 10.4678C15.975 9.56141 16.7098 8.82666 17.6161 8.82666C18.4583 8.82666 19.1523 9.46104 19.2464 10.278C19.4876 10.207 19.743 10.1689 20.0072 10.1689C20.2654 10.1689 20.515 10.2053 20.7513 10.2732C20.6508 8.62902 19.2856 7.32666 17.6161 7.32666C15.8814 7.32666 14.475 8.73298 14.475 10.4678C14.475 12.1372 15.7773 13.5024 17.4214 13.6029C17.3536 13.3666 17.3172 13.117 17.3172 12.8589C17.3172 12.5946 17.3553 12.3393 17.4263 12.098C16.6094 12.0039 15.975 11.3099 15.975 10.4678Z",
    fill: "#39005C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.c814735ddcffa70a112b844615e08338.svg";
export { ForwardRef as ReactComponent };